import { useEffect, useState } from 'react';

import { contractsApi } from '../../api/contracts.api';

export const useContract = (contractId?: number) => {
  const [contract, setContract] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!contractId) return;
    let mounted = true;
    setLoading(true);
    contractsApi
      .getContract(contractId)
      .then((data) => {
        if (mounted) setContract(data ?? null);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [contractId]);

  return { contract, setContract, loading };
};
